import { render } from "./Page.vue?vue&type=template&id=0f108dce&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=0f108dce&scoped=true&lang=css"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f108dce"]])

export default __exports__